// extracted by mini-css-extract-plugin
export var content = "defaultStyles-module--content--5503f";
export var detailsText = "defaultStyles-module--details-text--6c42e";
export var wrapAbove = "defaultStyles-module--wrap-above--b15d9";
export var wrapAboveAlt = "defaultStyles-module--wrap-above-alt--148fd";
export var wrapAboveContent = "defaultStyles-module--wrap-above-content--ff795";
export var wrapAboveContentWrap = "defaultStyles-module--wrap-above-content-wrap--57557";
export var wrapAboveFeaturedImage = "defaultStyles-module--wrap-above-featured-image--a63b1";
export var wrapAboveHeaderCard = "defaultStyles-module--wrap-above-header-card--5544a";
export var wrapAboveHeaderContent = "defaultStyles-module--wrap-above-header-content--92dbb";
export var wrapAboveText = "defaultStyles-module--wrap-above-text--25ec3";
export var wrapBelow = "defaultStyles-module--wrap-below--ef309";
export var wrapBelowElopement = "defaultStyles-module--wrap-below-elopement--7a91d";